module.exports = __webpack_public_path__ + "img/elantra8.fe02e4a7.jpeg";